module.exports = __webpack_public_path__ + "img/photo_2022-11-09_18-32-18.e6efd053.jpg";